export const HTTP_STATUS = {
  CREATED: 201,
};
